
import { ActionType } from '../actionTypes';
import { Action } from '../actions/spotsActions';
import { ErrorDto, FlyerPageSpotDto } from "../../dtos";


export interface SpotsState {
    spots?: FlyerPageSpotDto[];
    warnings?: string[] | null;
    loading?: boolean;
    error?: ErrorDto | null;
    type: string | null;
    isHorizontalOrientationForFrames: boolean;
    isSelectAll: boolean;
}

export class SpotsInitialState implements SpotsState {
    spots = [];
    loading = false;
    error = null;
    type = null;
    isHorizontalOrientationForFrames = true;
    isSelectAll = false;
    warnings = null;
}

const initialState = new SpotsInitialState();

const reducer = (state: SpotsState = initialState, action: Action): SpotsState => {

    switch (action.type) {

        // spots create
        case ActionType.POST_FLYER_SPOTS_CREATE_START:
            return { ...state, type: action.type, error: null, loading: true, warnings: null }

        case ActionType.POST_FLYER_SPOTS_CREATE_SUCCESS:
            return { ...state, type: action.type, spots: action.payload, error: null, loading: false, warnings: null }

        case ActionType.POST_FLYER_SPOTS_CREATE_ERROR:
            return { ...state, type: action.type, error: action.payload, loading: false, warnings: null }

        case ActionType.POST_FLYER_SPOTS_CREATE_COMPLETED:
            return { ...state, type: action.type, error: null, loading: false, warnings: null }


        // spots update
        case ActionType.POST_FLYER_SPOTS_UPDATE_START:
            return { ...state, type: action.type, error: null, loading: true, warnings: null }

        case ActionType.POST_FLYER_SPOTS_UPDATE_SUCCESS:
            return { ...state, type: action.type, spots: action.payload, error: null, loading: false, warnings: null }

        case ActionType.POST_FLYER_SPOTS_UPDATE_ERROR:
            return { ...state, type: action.type, error: action.payload, loading: false, warnings: null }

        case ActionType.POST_FLYER_SPOTS_UPDATE_COMPLETED:
            return { ...state, type: action.type, error: null, loading: false, warnings: null }

        // spots delete 
        case ActionType.POST_FLYER_SPOTS_DELETE_START:
            return { ...state, type: action.type, error: null, loading: true, warnings: null }

        case ActionType.POST_FLYER_SPOTS_DELETE_SUCCESS:
            return { ...state, type: action.type, spots: action.payload, error: null, loading: false, warnings: null }

        case ActionType.POST_FLYER_SPOTS_DELETE_ERROR:
            return { ...state, type: action.type, error: action.payload, loading: false, warnings: null }

        case ActionType.POST_FLYER_SPOTS_DELETE_COMPLETED:
            return { ...state, type: action.type, error: null, loading: false, warnings: null }

        case ActionType.CHANGE_ORIENTATION_NUMBERING_FOR_FRAMES:
            return { ...state, isHorizontalOrientationForFrames: action.payload }

        case ActionType.TOGGLE_SELECT_ALL_FRAMES:
            return { ...state, isSelectAll: action.payload }
        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_START:
            return {
                ...state, error: null, loading: false, type: action.type, warnings: null
            }
        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_SUCCESS:
            return {
                ...state, spots: action.payload.frames, warnings: action.payload.warnings, error: null, loading: false, type: action.type
            }
        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_COMPLETE:
            return {
                ...state, error: null, loading: false, type: action.type, warnings: null
            }
        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, warnings: null };
        // the default switch case must be included as followed:
        default:
            return state;
    }

}

export default reducer;